if (!customElements.get("modal-element")) {
  class modalElement extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.modal = this.querySelector('.modal');
      this.scrollPosition = window.scrollY || 0;
      this.closeModalButton = this.querySelector('.modal-close-btn');
      this.triggers = document.querySelectorAll(`[data-modal-target="${this.id}"]`);
      this.bindEvents();
    }

    bindEvents() {
      this.modal.addEventListener('click', (e) => this.handleModalClick(e));
      document.addEventListener('keydown', (e) => this.handleKeydown(e));
      this.triggers.forEach(btn => btn.addEventListener('click', () => this.openModal()));
    }

    handleModalClick(event) {
      const target = event.target;
      if (target === this.modal || target === this.closeModalButton) {
        this.closeModal();
      }
    }

    handleKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.closeModal();
      }
    }

    openModal() {
      this.modal.showModal();
      this.scrollPosition = window.scrollY;
      this.bodyLock(true);

      if (this.showOnlyOnce) {
        localStorage.setItem('infoModalShown', 'true');
      }
    }

    closeModal() {
      this.modal.close();
      this.bodyLock(false);
    }

    bodyLock(value) {
      const body = document.body;

      console.log(this.scrollPosition);
      

      if (value) {
        body.style.top = `-${this.scrollPosition}px`;
        body.style.overflow = "hidden";
        body.style.position = "fixed";
        body.style.width = "100%";
        return;
      }

      body.style.removeProperty("overflow");
      body.style.removeProperty("position");
      body.style.removeProperty("width");
      body.style.removeProperty("top");

      window.scrollTo(0, this.scrollPosition);
    }
  }

  customElements.define("modal-element", modalElement);
}